import React, { PureComponent } from 'react';
import ModalWrapper, { withOnClose } from '../ModalWrapper';
import Translator from '../../../requests/apa/Translator';
import Asset from "../../../requests/apa/Asset";
import Device from "../../../devices/device"
import './styles/_AAFModalActivaHBOMaxQR.scss';
import Utils, { setInitialFocus } from '../../../utils/Utils';
import { HIDE_MODAL } from '../../../actions/modal';
import store from '../../../store';
import { Button } from '../../../packages/components/lib/Button';

class AAFModalActivaHBOMaxQR extends PureComponent {
	constructor(props) {
		super(props);
		const { code, qrCode } = this.props.response || {};
        this.code = code || '';
		this.inactivityTimeoutMs = (this.props.inactivityTimeoutSeconds || 0) * 1000;

		//Icono
		this.icon = Asset.get('activahbomax_modalqr_logohbomax');
		//Botón cerrar
		this.textClose = Utils.cutPlayerString(Translator.get(`activahbomax_modalqr_boton_texto_cerrar`), 22);
		//Título
		this.title = Utils.cutPlayerString(Translator.get(`activahbomax_modalqr_texto_titulo`), 39);
		//Opción 1
		this.option1 = Utils.cutPlayerString(Translator.get(`activahbomax_modalqr_texto_subtitulo_opcion1`), 32);
		this.numberOption1Step1 = Utils.cutPlayerString(Translator.get('activahbomax_modalqr_opcion1_texto_digito_paso1'), 1);
		this.option1Step1 = Utils.cutPlayerString(Translator.get(`activahbomax_modalqr_opcion1_texto_parrafo1`), 80);
		this.qrImage = qrCode;
		this.numberOption1Step2 = Utils.cutPlayerString(Translator.get('activahbomax_modalqr_opcion1_texto_digito_paso2'), 1);
		this.option1Step2 = Utils.cutPlayerString(Translator.get(`activahbomax_modalqr_opcion1_texto_parrafo2`), 39);
		//Opción 2
		this.option2 = Utils.cutPlayerString(Translator.get(`activahbomax_modalqr_texto_subtitulo_opcion2`), 32);
		this.numberOption2Step1 = Utils.cutPlayerString(Translator.get('activahbomax_modalqr_opcion2_texto_digito_paso1'), 1);
		this.option2Step1 = Utils.cutPlayerString(Translator.get(`activahbomax_modalqr_opcion2_texto_parrafo1`), 80);
		this.option2Step1Link = Utils.cutPlayerString(Translator.get(`activahbomax_modalqr_opcion2_texto_enlace`), 34);
		this.numberOption2Step2 = Utils.cutPlayerString(Translator.get('activahbomax_modalqr_opcion2_texto_digito_paso2'), 1);
		this.option2Step2 = Utils.cutPlayerString(Translator.get(`activahbomax_modalqr_opcion2_texto_parrafo2`), 80);
		this.formattedCode = Utils.cutPlayerString(this.formatByThree(this.code), 9);
		this.numberOption2Step3 = Utils.cutPlayerString(Translator.get('activahbomax_modalqr_opcion2_texto_digito_paso3'), 1);
		this.option2Step3 = Utils.cutPlayerString(Translator.get(`activahbomax_modalqr_opcion2_texto_parrafo3`), 39);
		//Footer
		this.footerTextInfo = Utils.cutPlayerString(Translator.get(`activahbomax_modalqr_texto_aviso`), 115);
		
		this.keys = Device.getDevice().getKeys();

		this.closeModal = this.closeModal.bind(this);
	}

	componentDidMount() {
		setTimeout(() => {
			const closeButton = document.querySelector('#hbomax-qr-close-button');
			if (closeButton && closeButton.id) {
				setInitialFocus(`#${closeButton.id}`, false);
			}
		}, 300);

		if (this.inactivityTimeoutMs > 0) {
			this.inactivityTimeoutId = setTimeout(() => {
				this.closeModal();
			}, this.inactivityTimeoutMs);
		}
	}

	componentWillUnmount() {
		if (this.inactivityTimeoutId) {
			clearTimeout(this.inactivityTimeoutId);
		}
	}

	formatByThree = (code = '') => {
	    if (typeof code !== 'string') return '';
	    return code.match(/.{1,3}/g) && code.match(/.{1,3}/g).join(' - ') || '';
    };

	closeModal(e) {
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}

		if (this.inactivityTimeoutId) {
			clearTimeout(this.inactivityTimeoutId);
		}

		const dispatcher = (this.props && this.props.dispatch) || (store && store.dispatch);
		if (dispatcher && typeof dispatcher === 'function') {
			dispatcher({ type: HIDE_MODAL });
		}
	}
 		
	render() {
		return (
			<ModalWrapper>
				<div className='screen-qr-hbo-max'>
					<div className="qr-hbo-max_header">
						<div className="qr-hbo-max_header_container">
							<div className="qr-hbo-max_icon_header_container">
								<img src={this.icon}/>
							</div>
							<div className="qr-hbo-max_button_header_container">
							<Button 
								id="hbomax-qr-close-button"
								type="button" 
								variant={null} 
								className="qr-hbo-max_button_header focusable" 
								onClick={this.closeModal}
							>
								{this.textClose}
							</Button>
							</div>
						</div>
					</div>
					<div className="qr-hbo-max_info_container">
						<h1 className="qr-hbo-max_title">{this.title}</h1>
						<div className="qr-hbo-max_content"> 
							<div className="qr-hbo-max_column_left">
								<div className="qr-hbo-max_option_container">
									<p className="qr-hbo-max_option_text">
										{this.option1}
									</p>
								</div>
								<div className="qr-hbo-max_step_container">
									<div className="qr-hbo-max_step_number">
										{this.numberOption1Step1}
									</div>
									<div className="qr-hbo-max_step_info">
										<p className="qr-hbo-max_step_info_text">
											{this.option1Step1}
										</p>
										<div className="qr-hbo-max_step_info_image">
											<img src={this.qrImage}/>
										</div>
									</div>
								</div>
								<div className="qr-hbo-max_step_container last_step">
									<div className="qr-hbo-max_step_number">
										{this.numberOption1Step2}
									</div>
									<div className="qr-hbo-max_step_info">
										<p className="qr-hbo-max_step_info_text one_line">
											{this.option1Step2}
										</p>
									</div>
								</div>
							</div>
							<div className="qr-hbo-max_column_right">
								<div className="qr-hbo-max_option_container">
									<p className="qr-hbo-max_option_text">
										{this.option2}
									</p>
								</div>
								<div className="qr-hbo-max_step_container">
									<div className="qr-hbo-max_step_number">
										{this.numberOption2Step1}
									</div>
									<div className="qr-hbo-max_step_info">
										<p className="qr-hbo-max_step_info_text">
											{this.option2Step1}
										</p>
										<p className="qr-hbo-max_step_info_link">
											{this.option2Step1Link}
										</p>
									</div>
								</div>
								<div className="qr-hbo-max_step_container">
									<div className="qr-hbo-max_step_number">
										{this.numberOption2Step2}
									</div>
									<div className="qr-hbo-max_step_info">
										<p className="qr-hbo-max_step_info_text">
											{this.option2Step2}
										</p>
										<p className="qr-hbo-max_step_info_code">
                                            {this.formattedCode}
                                        </p>
									</div>
								</div>
								<div className="qr-hbo-max_step_container last_step">
									<div className="qr-hbo-max_step_number">
										{this.numberOption2Step3}
									</div>
									<div className="qr-hbo-max_step_info">
										<p className="qr-hbo-max_step_info_text one_line">
											{this.option2Step3}
										</p>
									</div>
								</div>
							</div>
						</div>
						<div className="qr-hbo-max_footer">
							<div className="qr-hbo-max_footer_container">
								<p className="qr-hbo-max_footer_text_info">
									{this.footerTextInfo}
								</p>
							</div>
						</div>
					</div>
				</div>
			</ModalWrapper>
		);
	}
}

export default withOnClose(AAFModalActivaHBOMaxQR);



// WEBPACK FOOTER //
// ./src/components/Modal/ActivaHBOMaxQR/AAFModalActivaHBOMaxQR.jsx